var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cancel-btn",class:_vm.$globalData.loading || _vm.$globalData.checked ? 'disabled' : '',on:{"click":_vm.emitClick}},[_c('span',[_vm._v("Cancel")])])}
var staticRenderFns = []

export { render, staticRenderFns }